// @ts-nocheck
import Button from 'atoms/button/button';
import Loader from 'atoms/loader';
import _ from 'lodash';
import * as advertisingSelectors from 'models/advertisings/selector';
import * as adModalSelectors from './selector';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGrid from 'templates/thetaGrid';
import { getPricingData } from './api';
import { Tprops } from './types';
import { AD_MODAL_TABLE_IDS } from './constants';
import ModalBody from 'atoms/modal/modalBody';
import ModalActions from 'atoms/modal/modalActions';
import { createFiltersFromQueries } from 'models/dynamicGrid/query';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import { useEffect } from 'react';
import { createPricingData, submitPricingParams } from './sagaActions';
import { updatePricingDataId } from './reducer';
import { REQUESTS } from 'utils/services/thetaretail/requests';

const EnterPricing = (props: Tprops) => {
	const { hideModal, handleNextClick, goBack } = props;
	const [ref, handleUpdateRef] = React.useState(null);
	const name = 'adSkus';
	const enterPricingData = useSelector((state) => adModalSelectors.getPricingData(state));
	const dispatch = useDispatch();
	const adData: any = useSelector((state) => adModalSelectors.getAdModalData(state, 'advertising')) || {};

	const gridConfig = {
		enableSelection: false,
		enableSorting: true,
	};

	useEffect(() => {
		dispatch(createPricingData());
	}, []);

	const pricingDataId = useSelector(adModalSelectors.getPricingDataId);

	const handleReviewAdClick = () => {
		if (localStorage.getItem('adIdForPricing') !== 'null' || adData.AdID !== '') {
			dispatch(submitPricingParams({ AdID: adData?.AdID }));
		}
		handleNextClick && handleNextClick();
	};

	const templateConfig = React.useMemo(() => {
		const effectiveAdTempId =
			localStorage.getItem('adIdForPricing') === null || localStorage.getItem('adIdForPricing') === 'null'
				? pricingDataId
				: localStorage.getItem('adIdForPricing');
		return {
			gridConfig,
			isFilterEnabled: true,
			tableId: 33,
			dataProviderOptions: {
				type: 'POST',
				...REQUESTS.POST.GET_PRICING_PARAMS,
				pathParams: {
					AdTempID: effectiveAdTempId,
				},
				version: 2,
				body: { adId: adData.AdID === '' ? null : adData.AdID },
			},
		};
	}, [pricingDataId, adData.AdID]);

	useEffect(() => {
		if (adData.AdID !== '') {
			localStorage.setItem('adId', adData.AdID);
		}
	}, [adData.AdID]);

	const renderLoader = () => {
		return (
			<StackItem isGrow isStretch align="center">
				<Loader />
			</StackItem>
		);
	};
	return (
		<>
			<ModalBody onDomRef={handleUpdateRef}>
				<Stack>
					{!pricingDataId ? renderLoader() : <ThetaGridPaginated parent={ref} config={templateConfig} />}
				</Stack>
			</ModalBody>
			<ModalActions>
				<Stack gutter="medium">
					<StackItem isGrow isStretch>
						<Stack align="left" gutter="small">
							<StackItem>
								<Button
									isText
									isSecondary
									name="Re-Select SKUs"
									handleClick={() => {
										localStorage.removeItem('adIdForPricing');
										goBack();
									}}
								/>
							</StackItem>
						</Stack>
					</StackItem>
					<StackItem>
						<Stack align="right" gutter="small">
							<StackItem>
								<Button isText isSecondary name="Cancel" handleClick={hideModal} />
							</StackItem>
							<StackItem isStretch align="right">
								<Button
									isPrimary
									name={'Review Ad'}
									handleClick={() => {
										localStorage.setItem('adIdForPricing', pricingDataId);
										handleReviewAdClick();
									}}
								/>
							</StackItem>
						</Stack>
					</StackItem>
				</Stack>
			</ModalActions>
		</>
	);
};

export default EnterPricing;
